<template>
  <div class="home-header">
    <div class="flex justify-between">
      <div class="home-header-left flex align-center">
        <img
          src="@/assets/images/home/parklogo.png"
          class="home-header-left-logo"
          alt=""
        />
        <span class="font28 text-white">泉港智慧停车</span>
      </div>
      <div class="home-header-right flex align-center">
        <img
          @click="searchParkinglot"
          src="@/assets/images/home/search.png"
          alt=""
        />
        <img @click="qrCode" src="@/assets/images/home/scan.png" alt="" />
      </div>
    </div>
    <!-- <img src="@/assets/images/home/home-banner1.jpg" class="home-header-banner-1" alt="" /> -->
    <!-- <img @click="toMouthCar" src="@/assets/images/home/home-banner.png" class="home-header-banner" alt="" /> -->
    <!-- hruting 修改于20221114轮播banner -->
    <!-- 必传，广告投放区域。1、首页banner  2、地图 3、快捷缴费的banner 4、支付界面 5.泊位停车-->
    <Swipe :areaType="1" :singleImg="singleImg" :className="`header-banner`"></Swipe>
    <warning-car :show.sync="showWarning" @comfirm="experience" />
  </div>
</template>

<script>
import WarningCar from "@/components/base/warning-car.vue";
import WarningLogin from "@/components/base/warning-login.vue";

import { encrypt } from "@/libs/aes";
import { timestampEncryConfig } from "@/config/timestampEncryConfig";
import { obj2Param } from "@/libs/tools";

import Axios from "axios";
import Swipe from "@/components/base/swipe.vue";

export default {
  name: "HomeHeader",
  components: {
    WarningCar,
    WarningLogin,
    Swipe,
  },
  data() {
    return {
      showWarning: false,
      showLogin: false,
      singleImg:require('@/assets/images/home/home-banner.png')
    };
  },
  mounted() {
    let that = this;
    if (localStorage.getItem("userId")) {
      let timeStamp = encodeURIComponent(
        encrypt(new Date().getTime(), timestampEncryConfig.field)
      );
      let url = `/qgvip/myHomeController/queryBindPlateNumAndCouponNum?token=${localStorage.getItem(
        "token"
      )}&timestamp=${timeStamp}`;
      Axios.post(url, { type: 5, userId: localStorage.getItem("userId") }).then(
        (res) => {
          if (res.data.code == 200 && res.data.data.bindPlateNum == 0) {
            that.showWarning = true;
          }
        }
      );
    }
  },
  methods: {
    qrCode() {
      if (localStorage.getItem("userId")) {
        wx.miniProgram.navigateTo({
          url: `/pages/scan/scan`,
        });
      } else {
        this.showLogin = true;
      }
    },
    searchParkinglot() {
      this.$router.push({
        name: "SearchParkinglot",
      });
    },

    experience() {
      this.$router.push({ path: "/mycar" });
    },
    toMouthCar() {
      if (localStorage.getItem("userId")) {
        let obj = {
          token: localStorage.getItem("token"),
          userId: localStorage.getItem("userId"),
          xcxOpenId: localStorage.getItem("openId"),
        };
        let str = `${
          process.env.VUE_APP_BASE_API
        }qgvip/monthlyCar/listIndex?${obj2Param(obj)}`;

        wx.miniProgram.navigateTo({
          url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(str)}`,
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.home-header {
  width: 750px;
  height: 375px;
  background: linear-gradient(180deg, #009af3, #fff);
  padding: 24px;
  box-sizing: border-box;

  .home-header-left {
    .home-header-left-logo {
      width: 40px;
      height: 30px;
      margin-right: 14px;
    }
  }

  .home-header-right {
    img {
      width: 32px;
      height: 32px;
      margin-left: 24px;
    }
  }

  .home-header-banner {
    width: 702px;
    height: 304px;
    margin-top: 20px;
    border-radius: 15px;
  }
  // .home-header-banner-1 {
  //     width: 531px;
  //     height: 304px;
  //     margin-top: 20px;
  //     border-radius: 4px;
  // }
  /deep/ .header-banner {
    width: 702px;
    height: 304px;
    margin-top: 20px;
    border-radius: 15px;
  }
  
}

</style>
